<template>
  <div class="login">
    <div class="login-title">您還未登入會員</div>
    <a :href="lineLoginUrl">
      <img src="@/images/btn-login-base@2x.jpg" alt="line">
    </a>
  </div>
</template>

<script>
export default {
  name: "memberLogin",
  data() {
    return {
      lineLoginUrl: this.$store.getters.getGlobalUrl + "login"
    };
  }
};
</script>

<style scoped lang="scss">
.login {
  padding-top: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.login-title {
  font-size: 24px;
  color: $secondaryDeepColor1;
}
img {
  width: 151px;
}
</style>
